import { Avatar, Button, Divider, Drawer, Stack } from '@mui/material';
import { Logo } from '@src/components/logo';
import { Text } from '@src/components/mui';
import { useTheme } from '@src/themes';
import { FC, ReactNode } from 'react';

interface IOSInstallDrawerProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Convite de instalação no iOS, que não tem diálogo nativo para abrir.
 *
 * O Safari não expõe `beforeinstallprompt`: adicionar à tela inicial é uma
 * ação manual pelo menu de compartilhamento. Sem botão para oferecer, o que
 * resta é ensinar o caminho -- daí os passos numerados.
 */
const IOSInstallDrawer: FC<IOSInstallDrawerProps> = ({ open, onClose }) => {
  const { COLORS } = useTheme();

  const renderStep = (order: number, instruction: ReactNode) => (
    <Stack direction={'row'} gap={1} width={'280px'} marginTop={2} alignItems={'center'}>
      <Avatar
        component={'span'}
        sx={{
          width: 24,
          height: 24,
          fontSize: 14,
          backgroundColor: COLORS.others.white,
          color: COLORS.primary.main,
        }}
      >
        {order}
      </Avatar>
      <Text variant='body1' fontSize={14} color={COLORS.others.white}>
        {instruction}
      </Text>
    </Stack>
  );

  return (
    <Drawer anchor='bottom' open={open} onClose={onClose} PaperProps={{ sx: { backgroundColor: COLORS.primary.main } }}>
      <Stack direction={'column'} display={'flex'} justifyContent={'center'} alignItems={'center'} padding={4}>
        <Logo width={120} />

        <Text
          variant='body2'
          fontSize={14}
          color={COLORS.others.white}
          sx={{ textTransform: 'uppercase', fontWeight: 'bold', marginBottom: 1, marginTop: 3 }}
        >
          e-método sempre à mão
        </Text>

        <Text variant='body1' fontSize={14} color={COLORS.others.white} sx={{ textAlign: 'center' }}>
          Para acesso rápido à sua coleta:
        </Text>

        {renderStep(
          1,
          <>
            Toque na opção <b>Compartilhar</b>
          </>
        )}
        {renderStep(
          2,
          <>
            Escolha <b>“Adicionar à Tela de Início”</b>
          </>
        )}

        <Divider sx={{ width: '100%', backgroundColor: COLORS.others.grayHard, marginY: 3 }} />

        <Button size='small' variant='text' onClick={onClose} fullWidth sx={{ color: COLORS.others.white }}>
          Talvez mais tarde
        </Button>
      </Stack>
    </Drawer>
  );
};

export { IOSInstallDrawer };
